<template>
  <ui-box class="ui-box-apply" bgType="light">
    <template v-slot:nav-left>
      <ui-tag class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">报名成功</span>
          <span class="label-text">报名成功</span>
        </div>
      </ui-tag>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div class="tip">
              <div
                class="icon"
                :class="{
                  pass: $lg(Info, 'approval_status', 0) == 0 || $lg(Info, 'approval_status', 0) == 1,
                  unpass: $lg(Info, 'approval_status', 0) == 2
                }"
              ></div>
              <div class="desc">{{ sub_tip }}</div>
            </div>
            <div class="progress-box">
              <div class="bg" :class="status"></div>
              <div class="filter" :class="{ active: $lg(Info, 'team_status', 0) >= 0 }">
                <div class="label-box">
                  <span class="label-shadow">初筛</span>
                  <span class="label-text">初筛</span>
                </div>
                <div class="icon"></div>
              </div>
              <div class="filter" :class="{ active: $lg(Info, 'team_status', 0) >= 2 }">
                <div class="label-box">
                  <span class="label-shadow">复筛</span>
                  <span class="label-text">复筛</span>
                </div>
                <div class="icon"></div>
              </div>
              <div class="filter" :class="{ active: $lg(Info, 'team_status', 0) >= 3 }">
                <div class="label-box">
                  <span class="label-shadow">终筛</span>
                  <span class="label-text">终筛</span>
                </div>
              </div>
            </div>
            <div class="players">
              <li v-for="(item, i) in player" :key="i">
                <span><i>{{ item.label }}: </i>{{ item.nick || '-' }}</span>
                <span><i>UID: </i>{{ item.uid || '-' }}</span>
              </li>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <ui-frame-bg class="btn prev" colorType="blue" @click.native="handleExit">
            <div class="label-box">
              <span class="label-shadow">完成</span>
              <span class="label-text">完成</span>
            </div>
          </ui-frame-bg>
        </div>
      </div>
    </template>
  </ui-box>
</template>

<script>
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';

export default {
  components: { UiBox, UiTag, UiFrameBg },
  inject: ['info_player', 'json_config', 'apply_info', 'handleStep'],
  data() {
    return {
      sub_tip: '',
      status: 'stage-1'
    }
  },
  computed: {
    player() {
      return this.info_player() || [];
    },
    tips() {
      let config = this.json_config();
      return this.$lg(config, 'tips', {});
    },
    Info() {
      return this.apply_info()
    }
  },
  watch: {
    'Info': {
      handler(val, oldVal) {
        if(val != oldVal) {
          let team_status = val.team_status;
          let approval_status = val.approval_status;
          this.getTip(team_status, approval_status)
          // 判断阶段
          if(team_status >= 3) {
            this.status = 'stage-3'
          }else if(team_status >= 2) {
            this.status = 'stage-2'
          }else if(team_status >= 0) {
            this.status = 'stage-1'
          }
        }
      },
      immediate: true,
      deep: true
    },
    'tips': {
      handler(val, oldVal) {
        if(val != oldVal) {
          let team_status = this.$lg(this.Info, 'team_status', 0);
          let approval_status = this.$lg(this.Info, 'approval_status', 0);
          this.getTip(team_status, approval_status)
        }
      },
      immediate: true
    }
  },
  methods: {
    getTip(filter=0, pass=0) {
      if(filter == 0 || filter == 1) {
        if(pass == 0) {
          this.sub_tip = this.tips['filter_early_default'] || '';
        }else if(pass == 1) {
          this.sub_tip = this.tips['filter_early_pass'] || '';
        }else if(pass == 2) {
          this.sub_tip = this.tips['filter_early_unpass'] || '';
        }
      }else if(filter == 2) {
        if(pass == 0) {
          this.sub_tip = this.tips['filter_early_pass'] || '';
        }else if(pass == 1) {
          this.sub_tip = this.tips['filter_again_pass'] || '';
        }else if(pass == 2) {
          this.sub_tip = this.tips['filter_again_unpass'] || '';
        }
      }else if(filter == 3) {
        if(pass == 0) {
          this.sub_tip = this.tips['filter_again_pass'] || '';
        }else if(pass == 1) {
          this.sub_tip = this.tips['filter_final_pass'] || '';
        }else if(pass == 2) {
          this.sub_tip = this.tips['filter_final_unpass'] || '';
        }
      }
    },
    handleExit() {
      this.handleStep(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  i {
    position: relative;
    @include sizeSet($width: 36px, $height: 36px);
    @include icon_status('apply_success_2', $hook: 'all');
    margin-right: get_vh(8px);
  }
  .label-box {
    .label-shadow {
      color: #FFFFFF;
    }
    .label-text {
      color: #133469;
    }
  }
}


.inner-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .scroll-box {
    flex: 1;
    width: 98.5%;
    margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;
    .info-box {
      width: get_vw(822px);
      margin: 0 auto get_vh(33px);
      text-align: center;
      .tip {
        min-height: get_vh(68px);
        max-width: get_vw(768px);
        margin: 0 auto get_vh(18px);
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon {
          width: get_vh(125px);
          height: get_vh(123px);
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          margin-bottom: get_vh(16px);
          flex-shrink: 0;
          background-image: $bg_decorate;
          background-size: get_vh(1472px) get_vh(639px);
          background-repeat: no-repeat;
          &.pass {
            background-position: get_vh(0px) get_vh(-300px);
          }
          &.unpass {
            background-position: get_vh(-135px) get_vh(-300px);
          }
        }
        .desc {
          flex: 1;
          font-size: get_vh(24px);
          color: #000;
        }
      }
      .progress-box {
        position: relative;
        height: get_vw(41px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #DEDEDE;
        border: get_vh(2px) solid #CCCCCC;
        border-radius: get_vh(10px);
        margin-bottom: get_vh(18px);
        .bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          &.stage-1 {
            width: 33.3333%;
            background-image: url('https://website.xdcdn.net/poster/58881/20250717/Kv9gveXy.png');
          }
          &.stage-2 {
            width: 66.6666%;
            background-image: url('https://website.xdcdn.net/poster/58881/20250717/KvAQuYWg.png');
          }
          &.stage-3 {
            width: 100%;
            background-image: url('https://website.xdcdn.net/poster/58881/20250717/KvAQutku.png');
          }
        }
        .filter {
          position: relative;
          width: get_vw(274px);
          height: 100%;
          border-radius: get_vh(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          @include fontSet(24px);
          // font-size: get_vh(24px);
          .icon {
            position: absolute;
            top: 50%;
            right: get_vh(22px);
            transform: translate3d(0, -50%, 0);
            width: get_vh(37px);
            height: get_vh(19px);
            background-image: $bg_decorate;
            background-size: get_vh(1472px) get_vh(639px);
            background-position: get_vh(-351px) get_vh(-170px);
            background-repeat: no-repeat;
          }
          .label-box {
            .label-shadow {
              color: transparent;
            }
            .label-text {
              color: #999;
            }
          }
          &.active {
            // background-color: #15459B;
            .icon {
              background-position: get_vh(-300px) get_vh(-170px);
            }
            .label-box {
              .label-shadow {
                color: #133469;
              }
              .label-text {
                color: #FFFFFF;
              }
            }
          }
        }
      }
      .players {
        padding: get_vh(26px) 0;
        background-color: #FFFFFF;
        border: get_vh(2px) solid #CCCCCC;
        border-radius: get_vh(10px);
        li {
          width: get_vw(746px);
          height: get_vh(40px);
          margin: 0 auto;
          color: #333;
          font-size: get_vh(20px);
          display: flex;
          justify-content: space-between;
          align-items: center;
          i {
            color: #cccccc;
            font-style: normal;
          }
        }
      }
    }
  }
  .bottom-box {
    height: get_vh(128px);
    display: flex;
    justify-content: center;
    .btn {
      position: relative;
      width: get_vh(266px);
      height: get_vh(70px);
      font-size: get_vh(28px);
      font-weight: bold;
      @include boxShadowSet_Btn;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      margin-top: get_vh(20px);
      &:active {
        opacity: 0.9;
      }
    }
  }
}
</style>